import Vue from "vue";
import Router from "vue-router";
import Clients from "../components/Clients.vue";
import Photos from "../components/Photos.vue";
import Treatments from "../components/Treatments";
import Agenda from "../components/Agenda";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Agenda",
      component: Agenda
    },
    {
      path: "/clientes",
      name: "Clientes",
      component: Clients
    },
    {
      path: "/agenda",
      name: "Agenda",
      component: Agenda
    },
    {
      path: "/fotos",
      name: "Fotos",
      component: Photos
    },
    {
      path: "/tratamentos",
      name: "Tratamentos",
      component: Treatments
    }
  ]
});
